import { useState } from "react";

import {
  CLEARED_PORTFOLIO_PROJECT_FILTER,
  PortfolioProjectFilterFields,
  type PortfolioProjectFilterValues,
} from "@/components/ProjectFilter/PortfolioProjectFilterFields";
import { useAnalyticsScope } from "@/modules/analytics/AnalyticsScopeContext";

export function usePortfolioAnalyticsProjectFilterDraft(): {
  fields: React.ReactNode;
  apply: () => void;
  clear: () => void;
} {
  const analyticsScope = useAnalyticsScope();
  const projectFilter = analyticsScope.type === "portfolio" ? analyticsScope.projectFilter : undefined;
  const [draftFilter, setDraftFilter] = useState<PortfolioProjectFilterValues>(projectFilter?.value ?? {});

  return {
    fields: projectFilter ? (
      <PortfolioProjectFilterFields
        projects={projectFilter.projects}
        value={draftFilter}
        onChange={setDraftFilter}
        includeProjectSelection
      />
    ) : null,
    apply: () => projectFilter?.onChange(draftFilter),
    clear: () => {
      setDraftFilter(CLEARED_PORTFOLIO_PROJECT_FILTER);
      projectFilter?.onChange(CLEARED_PORTFOLIO_PROJECT_FILTER);
    },
  };
}
